import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { errMsg } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(u, p);
      nav("/admin/dashboard");
    } catch (e2) {
      setErr(errMsg(e2));
    }
    setBusy(false);
  };

  return (
    <div className="login-page grain" data-testid="admin-login-page">
      <div className="login-card">
        <h1 className="disp">Admin</h1>
        <form onSubmit={submit}>
          <label className="field">
            <span>Username</span>
            <input className="inp" value={u} onChange={(e) => setU(e.target.value)} data-testid="login-username" />
          </label>
          <label className="field">
            <span>Password</span>
            <input
              className="inp"
              type="password"
              value={p}
              onChange={(e) => setP(e.target.value)}
              data-testid="login-password"
            />
          </label>
          {err && (
            <p className="login-err" data-testid="login-error">
              {err}
            </p>
          )}
          <button className="btn" type="submit" disabled={busy} data-testid="login-submit">
            {busy ? "…" : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
}
